import moment from 'moment'

const member = (status, option = '') => {
  const locale = localStorage.getItem('locale') || 'no'
  let endDate = null
  let beginDate = '2017-01-16'
  let freezePeriods = []
  let activatesOn = null
  let scheduledFreeze = null
  let paymentMethod = {}
  let docs = null

  const keys = [
    {
      type: 'nfc',
      code: '1234567890123',
      status: status === 'in_freeze' ? 'suspended' : 'active',
      valid_from: moment().subtract(30, 'days').format(),
      valid_to: null,
    },
    {
      type: 'rfid',
      code: '123456789',
      status: status === 'in_freeze' ? 'suspended' : 'active',
      valid_from: moment().subtract(30, 'days').format(),
      valid_to: null,
    },
    {
      type: 'pin',
      code: '123456',
      status: status === 'in_freeze' ? 'inactive' : 'active',
      valid_from: moment().subtract(30, 'days').format(),
      valid_to: moment().add(3, 'days').format(),
    },
  ]

  const presentations = {
    product: {
      no: 'Du meldte du deg inn via vårt Google-tilbud som ga deg trening ut februar 2017 for kr. 199,- i tillegg fikk du fri innmeldingsavgift på kr 249,- og 25 min med personlig trener. Hele beløpet blir belastet ved innmelding og står derfor forklart som startavgift. Medlemskapet løper automatisk fra 1. mars 2017 til kr 349,- pr. mnd. Ditt medlemskap er inngått med standard medlemsvilkår, som innebærer 1 mnd. oppsigelsestid.',
      en: 'You signed up via our Google offer which gave you training until February 2017 for NOK 199,- in addition you received a free registration fee of NOK 249,- and 25 minutes with a personal trainer. The entire amount is charged upon registration and is therefore explained as a start fee. The membership automatically runs from March 1, 2017 at NOK 349,- per month. Your membership has been entered into with standard membership terms, which involve 1 month. notice period.',
    },
    referrer: {
      no: 'EVO BUDDY<br /><br />EVO verdsetter gode ambassadører og gir deg som medlem fordelene. Verver du nye medlemmer til EVO, belønner vi deg med 50 % på treningsavgiften i 2 måneder for hvert medlem du verver. For å få tilbudet må din venn melde seg inn med din vervekode.<br /><br />Nye medlemmer betaler kr 0,- for inneværende måned, samt halv pris i de to påfølgende måneder og får en kartleggingstime med PT (50 min). Innmeldingsavgift på kr 249,- tilkommer.',
      en: 'EVO BUDDY<br /><br />EVO values good ambassadors and gives you the benefits as a member. If you refer new members to EVO, we reward you with 50% off the training fee for 2 months for each member you refer. To get the offer, your friend must sign up with your referral code.<br /><br />New members pay NOK 0,- for the current month, as well as half price for the two following months and receive a mapping session with PT (50 min). A registration fee of NOK 249,- is added.',
    },
  }

  let userKeys
  if (['pin_only', 'with_doc_signed'].includes(option)) {
    userKeys = [...keys.slice(2)] // PIN only
  } else if (option === 'with_nfc') {
    userKeys = [...keys.slice(0, 1), ...keys.slice(2)] // NFC and PIN
  } else if (option === 'no_access') {
    userKeys = null
  } else {
    userKeys = [...keys.slice(1)] // RFID and PIN
  }

  if (status === 'cancelled' || status === 'cancelled_in_presale' || status === 'cancelled_in_trial' || status === 'in_cancellation') {
    endDate = '2018-01-23'
  }

  if (status === 'in_trial' || status === 'presale') {
    beginDate = moment().add(-3, 'days').format()
    if (userKeys && userKeys.length > 1) { userKeys.shift() }
  }

  if (status === 'in_freeze') {
    freezePeriods = [{
      id: 'd5b3b7ed-75da-4bde-95c3-8e75c9c98819',
      begin_date: moment().startOf('month').format('YYYY-MM-DD'),
      end_date: moment().endOf('month').format('YYYY-MM-DD'),
    }]
    activatesOn = moment().endOf('month').add(1, 'day').format('YYYY-MM-DD')
  }

  if (option === 'used_freeze') {
    freezePeriods = [{
      id: 'd687b109-c830-42f8-96c3-ded4f0399503',
      begin_date: moment().add(-3, 'months').startOf('month').format('YYYY-MM-DD'),
      end_date: moment().add(-2, 'months').endOf('month').format('YYYY-MM-DD'),
    }]
    activatesOn = null
  } else if (option === 'scheduled_freeze') {
    freezePeriods = [{
      id: 'a81a6941-a5cf-444a-86c9-e311508d965e',
      begin_date: moment().add(2, 'months').startOf('month').format('YYYY-MM-DD'),
      end_date: moment().add(3, 'months').endOf('month').format('YYYY-MM-DD'),
    }]
    scheduledFreeze = {
      id: 'a81a6941-a5cf-444a-86c9-e311508d965e',
      begin_date: moment().add(2, 'months').startOf('month').format('YYYY-MM-DD'),
      end_date: moment().add(3, 'months').endOf('month').format('YYYY-MM-DD'),
    }
    activatesOn = freezePeriods[0].begin_date
  }

  if (option !== 'sepa_payment') {
    paymentMethod = {
      id: 'e57aa12d-d90e-4520-9aef-f19b36ed72ce',
      provider: 'dibs',
      type: 'credit_card',
      brand: 'VISA',
      details: '492556******2994',
      expire: '1910',
    }
  }

  if (option === 'with_doc_unsigned') {
    docs = [
      {
        id: 'f8cba48e-ce23-4a4e-8fac-93b24b036812',
        membership_id: '5b5a80c7-4bf2-47a5-bce1-80646fedb4f8',
        document_id: 'eda0d250-8cbe-471d-86b1-11d82885230c',
        name: 'Haugesund-EN',
        location: 'EVO Haugesund',
        template_id: 492487,
        template_slug: 'wAdohawntZvZjt',
        status: 'pending',
        external_document_id: null,
        document_url: null,
      },
    ]
    userKeys = null
  } else if (option === 'with_doc_signed') {
    docs = [
      {
        id: 'f8cba48e-ce23-4a4e-8fac-93b24b036812',
        membership_id: '5b5a80c7-4bf2-47a5-bce1-80646fedb4f8',
        document_id: 'eda0d250-8cbe-471d-86b1-11d82885230c',
        name: 'Haugesund-EN',
        location: 'EVO Haugesund',
        template_id: 234323,
        template_slug: 'EInubenTEnp',
        status: 'signed',
        external_document_id: 890319,
        document_url: 'https://docuseal.eu/file/WyJhMDI1YjA0Zi05YTJjLTQxNmMtYTI2Zi1iNmU2ZjI2M2E4MmYiLCJibG9iIiwxNzc2NjkxODIyXQ--dfdd369fcfef057fbc8b7b989a5fa3b5b9cab4969044b4b3a214e64fde165443/EVO%20Fitness%20-%20AT%20-%20Safety%20Measures%20-%20V4.pdf',
      },
    ]
  }

  const membership = {
    id: `${option === '' ? status : option}`,
    membership_number: 143334,
    created_at: '2017-01-16 18:01:56 +0000',
    status: status,
    activates_on: activatesOn,
    begin_date: beginDate,
    end_date: endDate,
    referral_code: 'K03O0',
    gdpr_opt_in: true,
    sheltered: false,
    locale: 'en-NO',
    freeze_periods: freezePeriods,
    scheduled_freeze: scheduledFreeze,
    access_chip: { fee: 2000, pin_days: 20 },
    operator: {
      id: '848c0413-5e75-4f7a-87ad-e45a937c6318',
      name: 'no',
      country: null,
      timezone: null,
      currency: 'NOK',
    },
    profile: {
      gdpr_opt_in: null,
      first_name: 'Peter',
      last_name: 'Holmen',
      gender: 'MALE',
      birthdate: '1990-03-25',
      email: 'vivian@dickensklocko.org',
      address: {
        street: 'Kirkegata 17',
        postal_code: '0382',
        postal_location: 'OSLO',
        country: 'Norway',
      },
      mobile: {
        prefix: '+47',
        number: '34280786',
      },
    },
    location: {
      id: '2ce04e23-361e-4e8e-b73b-55ac3c27b558',
      name: 'EVO Haugesund',
      opening_date: '2013-08-15',
      closing_date: null,
    },
    product: {
      presentation: presentations.product[locale.substring(0, 2)],
      locations: 'all',
      schedule: 'fulltime',
      require_phone_verification: false,
    },
    current_payment_method: paymentMethod,
    keys: userKeys,
    referral: {
      name: 'EVO BUDDY Boost 4-7 mars 19 (3 mnd med 50%) +1 kartleggingstime (50)',
      discount_months: 3,
      discount_percentage: 50,
      pt_hours: 1,
      presentation: presentations.referrer[locale.substring(0, 2)],
    },
  }

  if (docs !== null) {
    membership.documents = docs
  }
  if (status === 'active' && option === '') {
    membership.my_referrals = [
      {
        created_at: '2026-03-02 12:23:34.123',
        first_name: 'A',
        last_name: 'Person',
        discount_percentage: 50,
        credits_used: 0,
        credits_available: 1,
      },
      {
        created_at: '2026-01-02T21:32:43',
        first_name: 'Ann',
        last_name: 'Reffed',
        discount_percentage: 30,
        credits_used: 1,
        credits_available: 1,
      },
      {
        created_at: '2025-10-04 23:12:01+01:00',
        first_name: 'Una',
        last_name: 'Vailable',
        discount_percentage: 50,
        credits_used: 2,
        credits_available: 0,
      },
    ]
  }

  return membership
}

const active = member('active')
const inTrial = member('in_trial')
const presale = member('presale')
const cancelled = member('cancelled')
const cancelledInPresale = member('cancelled_in_presale')
const cancelledInTrial = member('cancelled_in_trial')
const inFreeze = member('in_freeze')
const inCancellation = member('in_cancellation')
const usedFreeze = member('active', 'used_freeze')
const scheduledFreeze = member('active', 'scheduled_freeze')
const sepaPayment = member('active', 'sepa_payment')
const pinOnly = member('active', 'pin_only')
const withNfc = member('active', 'with_nfc')
const noAccess = member('active', 'no_access')
const withDocSigned = member('active', 'with_doc_signed')
const withDocUnsigned = member('active', 'with_doc_unsigned')

export default [
  active,
  cancelled,
  cancelledInPresale,
  cancelledInTrial,
  inCancellation,
  inFreeze,
  inTrial,
  presale,
  usedFreeze,
  scheduledFreeze,
  sepaPayment,
  pinOnly,
  withNfc,
  noAccess,
  withDocSigned,
  withDocUnsigned,
]

export {
  active,
  cancelled,
  cancelledInPresale,
  cancelledInTrial,
  inCancellation,
  inFreeze,
  inTrial,
  presale,
  usedFreeze,
  scheduledFreeze,
  sepaPayment,
  pinOnly,
  withNfc,
  noAccess,
  withDocSigned,
  withDocUnsigned,
}
